import { render } from "./PersonForm.vue?vue&type=template&id=5a3299c6"
import script from "./PersonForm.vue?vue&type=script&lang=js"
export * from "./PersonForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__